import React, { Component } from 'react';
import { connect } from "react-redux";
import { dispatchCommonData } from '../../Actions/index';
import { Grid, Card, Typography, CardContent } from '@material-ui/core';
import CountUp from 'react-countup';
import { fetchDistrictData, districtDataTwo } from '../../api/index';
import styles from './home.module.css'
import * as  constants from '../../constants/constants';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'

class home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      state: constants.constantsVariables.state,
      stateData: [],
    }
  }

  async componentDidMount() {
    const response = await fetchDistrictData();
    const stateData = await districtDataTwo();
    let data = [response];
    this.setState({ data, stateData });
  }

  render() {
    const { data, stateData } = this.state;
    return (
      <div className={styles.container}>
        <Typography justify="center" variant="h5" component="h2">Status of {this.props.selectedState.name}</Typography>
        {data.map((n, i) => {
          return (
            <Grid container justify="center" key={i} className={styles.card}>
              <Grid item xs={12} md={12} component={Card} >
                <CardContent >
                  <Typography variant="h5" component="h2">
                    Confirmed: <CountUp start={0} end={n[this.props.selectedState.value].total.confirmed} duration={1.} separator="," />
                  </Typography>
                  <Typography variant="h5" component="h2">
                    Recovered: <CountUp start={0} end={n[this.props.selectedState.value].total.recovered} duration={1} separator="," />
                  </Typography>
                  <Typography variant="h5" component="h2">
                    Active: <CountUp start={0} end={(n[this.props.selectedState.value].total.confirmed - n[this.props.selectedState.value].total.deceased) - n[this.props.selectedState.value].total.recovered} duration={1} separator="," />
                  </Typography>
                  <Typography variant="h5" component="h2">
                    Deaths: <CountUp start={0} end={n[this.props.selectedState.value].total.deceased} duration={1} separator="," />
                  </Typography>
                </CardContent>
              </Grid>

            </Grid>
          );
        })}
        {stateData.map((n, i) => {
          return (
            <div className={styles.tableMenu} key={i}>
              {n.statecode.toString() === this.props.selectedState.value.toString() ?
                <Table className={styles.table}>
                  <Thead className={styles.head}>
                    <Tr>
                      <Th>District</Th>
                      <Th>Confirmed</Th>
                      <Th>Recovered</Th>
                      <Th>Active</Th>
                      <Th>Deaths</Th>
                    </Tr>
                  </Thead>
                  <Tbody  className={styles.tbody}>
                    {n.districtData.map((m, k) => {
                      return (
                        <Tr key={k}>
                          <Td>{m.district}</Td>
                          <Td>{m.confirmed}</Td>
                          <Td>{m.recovered}</Td>
                          <Td>{m.active}</Td>
                          <Td>{m.deceased}</Td>
                        </Tr>
                      );
                    })}
                  </Tbody>
                </Table>
                : ''}
            </div>
          );
        })}
      </div>
    );
  }
}


const mapStateToProps = state => {
  return {
    selectedState: state.common.stateData,
  };
};

const mapDispatchToProps = {
  dispatchCommonData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(home);